import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { retrieveToken } from "../../../utils/storage";

export const adminDashboardApi = createApi({
  reducerPath: "dashboard",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => ({
    getCardStats: builder.query({
      query: ({ adminId = "", studioId = "", userId = "" }) => ({
        url: `/admin/Stats/summary?adminId=${adminId}&studioId=${studioId}&userId=${userId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
    getMonthWeekStats: builder.query({
      query: ({ adminId = "", studioId = "", userId = "" }) => ({
        url: `/admin/Stats/docssummary?adminId=${adminId}&studioId=${studioId}&userId=${userId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
    getCategoryStats: builder.query({
      query: ({ adminId = "", studioId = "", userId = "" }) => ({
        url: `/admin/Stats/docsmacrosummary?adminId=${adminId}&studioId=${studioId}&userId=${userId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
    getDownloadStats: builder.query({
      query: (query = "") => ({
        url: `/admin/Stats/summary/export/excel?summaryType=${query}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${retrieveToken()}`,
        },
        responseHandler: async (response) => await response.blob(),
        cache: "no-cache",
      }),
    }),
  }),
});

export const {
  useGetCardStatsQuery,
  useGetMonthWeekStatsQuery,
  useGetCategoryStatsQuery,
  useLazyGetDownloadStatsQuery,
} = adminDashboardApi;
